import React from 'react';

import { NullableFormatter } from 'Components/formatters';

export const labelCell = v => <NullableFormatter value={v.value} withTitle/>;
